// import SelectedDocument from '@containers/DigitalAnalyst/components/SelectedDocument';
import { SelectedDocument } from '@ui/SelectedDocument';
import React from 'react';
import styled from 'styled-components';

const SelectedDocsRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SelectedDocuments = ({ value, onRemoveDocument }) => {
  if (value.length === 0) return null;

  return (
    <SelectedDocsRowWrapper>
      {value?.map((d) => (
        <SelectedDocument key={d?.id} doc={d} handleRemove={onRemoveDocument} />
      ))}
    </SelectedDocsRowWrapper>
  );
};
